import { render, staticRenderFns } from "./PageActivityLevel.vue?vue&type=template&id=15c6f952"
import script from "./PageActivityLevel.vue?vue&type=script&lang=js"
export * from "./PageActivityLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports